import {Menu, Layout} from "antd";
import {Brand} from "../Components/Brand";
import {getSiderConfig} from "../Configs/siderConfig";
import React, {useState} from "react";
import PromptDrawer from "../Components/PromptDrawer";
import {GENERAL_TEMPLATES} from "../constants/prompts/generalTemplates";

const { Sider } = Layout;


const SideBar = ({collapsed, setCollapsed, className=''}) => {
    const [drawerVisible, setDrawerVisible] = useState(false);
    const toggleDrawer = () => setDrawerVisible(!drawerVisible);
    const handleLogout = ()=>{}



    return (
        <>
            <Sider collapsible
                   className={className}
                   collapsed={collapsed}
                   onCollapse={setCollapsed}
                   style={{
                   }}
            >
                <div className={'overlay'}>
                <Brand route={'/'}/>
                <Menu
                    className={'py-6 my-6'}
                    defaultSelectedKeys={['1']}

                    mode="inline"
                    theme="dark"
                    style={{
                        border: 'none',
                        background: 'transparent',
                    }}
                    items={getSiderConfig(handleLogout, toggleDrawer)}
                />
                </div>
            </Sider>
            <PromptDrawer
                visible={drawerVisible}
                onClose={toggleDrawer}
                prompts={GENERAL_TEMPLATES}
            />
        </>
    )
}

export default SideBar;